import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive({
  selector: '[appKeyboardShortcut]'
})
export class KeyboardShortcutDirective {
  @Input() shortcuts: { [key: string]: boolean } = {};
  @Output() shortcutTriggered = new EventEmitter<string>();

  @HostListener('window:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent): void {
    const isModifierPressed = event.ctrlKey || event.metaKey;
    
    if (!isModifierPressed) {
      return;
    }

    const key = event.key.toLowerCase();
    
    if (this.shortcuts[key]) {
      event.preventDefault();
      this.shortcutTriggered.emit(key);
    }
  }
}
